import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'
import reportWebVitals from './reportWebVitals'

import '@phillipsauctionhouse/ui-react/fonts.css'
import './global.css'

;(async () => {
  // fix for safari where this runs too quickly
  //
  // it appears the 'initial' page loads as:
  // 1. load html from MS
  // 2. load an run installHook script, which downloads our html index file
  // 3. download assets defined in index.html
  // 4. load DOM
  // 5. run this script (marked as defer)
  //
  // on further runs in Safari, this order ets screwed up
  // 1. load html from MS
  // 2. load cached assets defined in index.html
  // 3.?. run this script (marked as defer)
  // 3.?. load an run installHook script, which downloads our html index file
  // 3.? download assets defined in index.html
  // 3.? load DOM
  // hence... sometimes the DOM has not loaded before we try to mount
  //
  // this tweak fixes it by waiting for the "root" element to be loaded before continuing
  let element = document.getElementById('root')
  while (element === null) {
    await new Promise((r) => setTimeout(r, 10))
    element = document.getElementById('root')
  }

  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root'),
  )

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals()
})()
